import { apiPostAuth, apiGetAuth } from '@/utils/api'
import { API_EMPLOYEE_MUTATION } from '@/utils/api-url'
import { notificationDanger } from '@/utils/notification'

const state = {
  mutation_list: {
    isLoading: false,
    data: {}
  },
  mutation_history: {
    isLoading: false,
    data: [],
    pagination: {
      page: 1,
      total_pages: 1,
      total: 0
    }
  },
  mutation_detail: {
    isLoading: false,
    data: {}
  },
  modal_mutasi: {
    isOpen: false,
    isLoading: false
  }
}

const mutations = {
  'SET_MUTATION_LIST': (state, payload) => {
    state.mutation_list = payload
  },
  'SET_MUTATION_HISTORY': (state, payload) => {
    state.mutation_history = payload
  },
  'SET_MUTATION_DETAIL': (state, payload) => {
    state.mutation_detail = payload
  },
  'SET_MODAL_MUTASI': (state, payload) => {
    state.modal_mutasi = payload
  }
}

const actions = {
  async submitMutation(context, payload) {
    try {
      context.commit('SET_MODAL_MUTASI', { isOpen: true, isLoading: true })
      const response = await apiPostAuth(API_EMPLOYEE_MUTATION.CREATE, payload)
      context.commit('SET_MODAL_MUTASI', { isOpen: false, isLoading: false })
      return response.data
    } catch (error) {
      context.commit('SET_MODAL_MUTASI', { isOpen: false, isLoading: false })
      notificationDanger(error)
    }
  },
  async getMutationList(context, payload) {
    try {
      context.commit('SET_MUTATION_LIST', { isLoading: true, data: {} })
      const response = await apiGetAuth(API_EMPLOYEE_MUTATION.LIST, payload)
      context.commit('SET_MUTATION_LIST', { isLoading: false, data: response.data })
    } catch (error) {
      context.commit('SET_MUTATION_LIST', { isLoading: false, data: {} })
      notificationDanger(error)
    }
  },
  async uploadAddendum(context, file) {
    try {
      const formData = new FormData()
      formData.append('addendum_file', file)
      const response = await apiPostAuth(API_EMPLOYEE_MUTATION.UPLOAD_ADDENDUM, formData)
      return response.data
    } catch (error) {
      notificationDanger(error)
    }
  },
  async getMutationDetail(context, id) {
    try {
      context.commit('SET_MUTATION_DETAIL', { isLoading: true, data: {} })
      const response = await apiGetAuth(API_EMPLOYEE_MUTATION.BY_ID(id))
      context.commit('SET_MUTATION_DETAIL', { isLoading: false, data: response.data?.data })
    } catch (error) {
      context.commit('SET_MUTATION_DETAIL', { isLoading: false, data: {} })
      notificationDanger(error)
    }
  },
  async getMutationHistory(context, payload) {
    const employeeId = payload?.employee_id || payload?.employeeId || ''
    if (!employeeId) {
      context.commit('SET_MUTATION_HISTORY', { isLoading: false, data: [] })
      return
    }
    try {
      context.commit('SET_MUTATION_HISTORY', { isLoading: true, data: [], pagination: {} })
      const response = await apiGetAuth(API_EMPLOYEE_MUTATION.HISTORY(employeeId), {
        page: payload?.page || 1,
        limit: payload?.limit || 5
      })
      const paginationData = response.data?.other || response.data?.pagination || {}
      context.commit('SET_MUTATION_HISTORY', { 
        isLoading: false, 
        data: response.data?.data || [],
        pagination: {
          page: paginationData.page || 1,
          total_pages: paginationData.total_pages || 1,
          total: paginationData.total || 0,
          per_page: paginationData.per_page || 5
        }
      })
    } catch (error) {
      context.commit('SET_MUTATION_HISTORY', { isLoading: false, data: [], pagination: {} })
      notificationDanger(error)
    }
  }
}

const getters = {
  get_mutation_list: state => state.mutation_list,
  get_mutation_history: state => state.mutation_history,
  get_mutation_detail: state => state.mutation_detail,
  get_modal_mutasi: state => state.modal_mutasi
}

const namespaced = true
export default {
  namespaced,
  state,
  mutations,
  actions,
  getters
}
